/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pharmacy-consumer.reducer';

export const PharmacyConsumerDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pharmacyConsumerEntity = useAppSelector(state => state.pharmacyConsumer.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pharmacyConsumerDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.pharmacyConsumer.detail.title">PharmacyConsumer</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumer.id">Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumerEntity.id}</dd>
          <dt>
            <span id="consumerName">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumer.consumerName">Consumer Name</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumerEntity.consumerName}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumer.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumerEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumer.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumerEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumer.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumerEntity.lastupdated}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumer.active">Active</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumerEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumer.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumerEntity.cursor}</dd>
          <dt>
            <span id="taxCode">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumer.taxCode">Tax Code</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumerEntity.taxCode}</dd>
          <dt>
            <span id="drugLicenceNumber">
              <Translate contentKey="tinyMedicRestApp.pharmacyConsumer.drugLicenceNumber">Drug Licence Number</Translate>
            </span>
          </dt>
          <dd>{pharmacyConsumerEntity.drugLicenceNumber}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyConsumer.contactCode">Contact Code</Translate>
          </dt>
          <dd>{pharmacyConsumerEntity.contactCode ? pharmacyConsumerEntity.contactCode.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyConsumer.consumer">Consumer</Translate>
          </dt>
          <dd>{pharmacyConsumerEntity.consumer ? pharmacyConsumerEntity.consumer.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyConsumer.supplier">Supplier</Translate>
          </dt>
          <dd>{pharmacyConsumerEntity.supplier ? pharmacyConsumerEntity.supplier.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pharmacy-consumer" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pharmacy-consumer/${pharmacyConsumerEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PharmacyConsumerDetail;
